import { Language } from './types';

const BASE_LABELS = {
  modalWelcomeTitle: '¡Hi {{name}}!',
  modalWelcomeMessage:
    'At EFEX, we continue to grow and transform. To enhance your experience and offer you new services such as accounts in USD, EUR, CAD, GBP, CNY, MXN, and COP, we are changing our banking provider in the United States. We will have a transition process during which we will enable a new account in the USA.',
  modalWelcomeMessage2:
    'Below find the new coordinates of your EFEX bank account:',
  modalWelcomeAlertMessage:
    'This service has no additional cost and your platform will continue to operate in the same way as you have been doing (the previous account in BREX to add funds will stop operating as of May 25)',
  modalWelcomeOkBtn: 'Ok',
  modalWelcomeDoubtsBtn: 'I have doubts',
  modalWelcomeNotShowBtn: 'Do not show more',
  modalWelcomeIntercomMessage: 'I have questions about my new bank account.',
  modalWelcomeTransferMethod: 'Transfer method',
  modalWelcomeTransferMethodDetail: 'Domestic Wire or ACH',
  modalWelcomeAccount: 'Account number',
  modalWelcomeRoutingNumber: 'Routing number',
  modalWelcomeRoutingNumberAch: 'Routing number (ACH)',
  modalWelcomeAccountType: 'Account type',
  modalWelcomeReceipt: 'Beneficiary',
  modalWelcomeReceiptAddress: 'Recipient business address',
  modalWelcomeBankName: 'Receiving bank',
  modalWelcomeBankAddress: 'Bank address',
};

type LabelsLanguage = keyof typeof BASE_LABELS;

const MODAL_WELCOME_NEWS_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LABELS,
  ES: {
    modalWelcomeTitle: '¡Hola {{name}}!',
    modalWelcomeMessage:
      'En EFEX seguimos creciendo y transformándonos. Para mejorar tu experiencia y ofrecerte nuevos servicios como cuentas en USD, EUR, CAD, GBP, CNY, MXN y COP, estamos cambiando nuestro proveedor bancario en Estados Unidos. Tendremos un proceso de transición durante el cual vamos a habilitar una nueva cuenta en USA.',
    modalWelcomeMessage2:
      'A continuación encuentra las nuevas coordenadas de tu cuenta bancaria en EFEX:',
    modalWelcomeAlertMessage:
      'Este servicio no tienen ningún costo adicional y tu plataforma seguirá operando de la misma forma como lo has venido haciendo (la cuenta anterior en BREX dejará de operar a partir del 29 de Mayo).',
    modalWelcomeOkBtn: 'De acuerdo',
    modalWelcomeDoubtsBtn: 'Tengo dudas',
    modalWelcomeNotShowBtn: 'No volver a mostrar',
    modalWelcomeIntercomMessage:
      'Tengo preguntas sobre mi nueva cuenta bancaria.',
    modalWelcomeTransferMethod: 'Método de transferencia',
    modalWelcomeTransferMethodDetail: 'Wire doméstico o ACH',
    modalWelcomeReceipt: 'Destinatario',
    modalWelcomeReceiptAddress: 'Dirección del destinatario',
    modalWelcomeRoutingNumber: 'Número de routing',
    modalWelcomeRoutingNumberAch: 'Número de routing (ACH)',
    modalWelcomeAccount: 'Número de cuenta',
    modalWelcomeAccountType: 'Tipo de cuenta',
    modalWelcomeBankName: 'Banco receptor',
    modalWelcomeBankAddress: 'Dirección del banco',
  },
};

export default MODAL_WELCOME_NEWS_LABELS;
